import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-update-mdm>
  <paedml-modal prefix={opts.prefix} 
      heading={opts.heading} opname={opts.opname} edit={opts.edit} 
      selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
      submitfunc={submitHandler}>
  
    <yield to="fields">
      <div class="row" if={!parent.data.initialized}>
          <div class="col-md-12">
            <div class="mt-2 mr-1 p-2 border border-danger">
              <span><paedml-icon icon="fas-exclamation-triangle" simple="danger" />
                  <strong class="text-danger pl-1 pt-2">Der MDM-Server ist noch nicht gestartet oder vollständig konfiguriert. Der MDM-Server kann nicht aktualisiert werden.</strong>
              </span>
              </div>
          </div>
      </div>

      <div class="row" if={parent.data.initialized}>
        <div class="col-md-12">
          <p>Die MDM Umgebung wird aktualisiert.</p>
        </div>
      </div>
      <div class="row" if={parent.data.initialized}>
          <div class="col-md-12">
            <div class="mt-2 mr-1 p-2 border border-info">
              <span><paedml-icon icon="fas-info-circle" simple="info" />
                  <strong class="text-info pl-1 pt-2">Update der MDM Umgebung kann bis zu 5 Minuten dauern.</strong>
              </span>
              </div>
          <div class="p-2"></div>
          </div>
      </div>
      <div class="row" if={parent.data.initialized} if={parent.data.initialized}>
        <div class="m-2 p-2">
          <span class="pl-1 pt-2">Es werden Jobs erstellt, um die MDM Umgebung zu aktualisieren.</span>
          <p></p>
          <paedml-form-input name="redirect" placeholder="Nach der Ausführung zur 'JobQueue'-Ansicht springen" fgclass="py-1"
            type="checkbox" revlut="jaNein"
            />
        </div>
      </div>
    </yield>
  </paedml-modal>
    
    <script>
      import { handleSubmitCreateOrEdit } from '../../util/api-util'
      import API from '../../api'
      
      this.opname = this.opts.opname
      this.data = {}
      this.edit = true

      this.data = {
        initialized: false,
        redirect: false
      }

      this.on('dataRequested', (e) => {
        let status = e.data()[0][8]
        this.data.initialized = status === 5
      })

      this.submitHandler = formData => {
      
        if(!this.data.initialized){
          return Promise.resolve('Operation abgebrochen')
        }

        return API.mdm.update().then(rsp => {
          const [data, status] = rsp
          if (status.error) return Promise.reject('Kommunikationsfehler mit dem Server')

          if(status.success) {
            
            if (this.data.redirect)  setTimeout(() => { 
              $('body').removeClass('modal-open')
              window.location.href = '/#jobverwaltung/jobs' 
            }, 500)

            this.parent.trigger('reloadTable')

            return 'Update der MDM Umgebung wurde erfolgreich gestartet.'
          }
        })
    }
    </script>
</paedml-modal-update-mdm>